import api from './api'
import type { WorkspaceWebhookSettings } from '@/types'
import type { ApiResponse, UpdateWorkspaceWebhookSettingsRequest } from '@/types/api'

const WebhookSettingsService = {
  async get(): Promise<WorkspaceWebhookSettings> {
    const response = await api.get<ApiResponse<WorkspaceWebhookSettings>>('/api/v1/webhooks/settings')
    return response.data.data
  },

  async update(data: UpdateWorkspaceWebhookSettingsRequest): Promise<WorkspaceWebhookSettings> {
    const response = await api.put<ApiResponse<WorkspaceWebhookSettings>>('/api/v1/webhooks/settings', data)
    return response.data.data
  },

  async regenerateToken(): Promise<WorkspaceWebhookSettings> {
    const response = await api.post<ApiResponse<WorkspaceWebhookSettings>>(
      '/api/v1/webhooks/settings/regenerate-token',
    )
    return response.data.data
  },
}

export default WebhookSettingsService
